export default [
    {
        path: '/endoscope-ai-report-view',
        name: 'EndoscopeAiReportView',
        component: () => import("@/pages/endoscope/AIReportView.vue"),
      },
]


// WEBPACK FOOTER //
// ./src/router/modules/endoscopeRoutes.js